'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/promise/index.js
// module id = 657
// module chunks = 17